import React from "react";
import PropTypes from "prop-types";
import ShowMoreText from "./showMoreText";

export const CategoryHeader = ({label, description, image}) => {
    return (
        <div className="category-header">
            <div className="category-header-content a">
                <div className="category-header-content-inner">
                    <h1 className="category-title">{label}</h1>
                    {
                        description &&
                        <ShowMoreText
                            text={description}
                            characters="220"
                            className="category-description"
                        />
                    }
                </div>
            </div>
            <div className="category-header-image" style={{
                backgroundImage: `url(${image})`, imageRendering: 'auto',
            }}>

            </div>

        </div>
    );
};

CategoryHeader.propTypes = {
    label: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
};

CategoryHeader.defaultProps = {
    label: null,
    description: null,
    image: null,
};
